import { Container, Col, Row } from "reactstrap";
import { Fields } from "@repoflow/components/fields";
import { useSectionContext } from "@repoflow/components/section";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-inner";
import * as tags from "@repoflow/form-schema/widgets/tag";
import * as OrganizationQL from "queries/organization";
import * as KeyQL from "queries/domain-key";
import * as KeyAccess from "components/key-access";
import { ApolloConsumer } from "@apollo/client";
import { Secret } from "./secret";

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = (props) => (
  <ApolloConsumer>
    {(client) => <ContentHandler {...props} client={client} />}
  </ApolloConsumer>
);

const ContentHandler = ({
  client,
  match: {
    params,
    params: { domainId },
  },
}) => {
  const { values, schema, base } = useSectionContext();

  return (
    <>
      <Container className="mt-4">
        <Row>
          <Col>
            <div className="float-right">
              <Link className="btn btn-primary" to={`${base}/edit`}>
                Edit
              </Link>{" "}
              <Link className="btn btn-danger" to={`${base}/remove`}>
                Remove
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Fields
              schema={schema}
              values={values}
              target={{ $ref: "/Public/Domain" }}
              config={{
                "/Public/Domain": {
                  fields: ["domain",
                    "domainId",
                    "description",
                    "publicKey",
                    "webhookRoute"],
                },
              }}
            />
          </Col>
        </Row>
        {/* privateKey and webhookSecret are deliberately not in the field list
            above: they are credentials, and <Fields> renders strings in the
            clear. */}
        <Row>
          <Col>
            <Secret label={"Private Key"} value={values && values.privateKey} />
            <Secret label={"Webhook Secret"} value={values && values.webhookSecret} />
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col>
            <Link className={"btn btn-primary"} to={`${base}/organization/new`}>
              <i className="fa fa-plus" /> Add Organization
            </Link>
          </Col>
        </Row>
        <div className="mt-2"></div>
        <Row>
          <Col>
            {/* `more` shows only when the API reports a next page. DynamoDB
                sets its cursor whenever a query fills its Limit, so a list of
                exactly 5 still offers "Show more" and the section it leads to
                then holds those same 5. */}
            <List
              onData={(results, data) => { }}
              path={"viewer.account.domains.get.organizations"}
              query={OrganizationQL.list}
              variables={params}
              schema={schema}
              target={{ $ref: "/Public/Organization" }}
              empty={"No organizations yet."}
              more={<Link to={`${base}/organization`}>Show more</Link>}
              config={{
                "/Public/Organization": {
                  fields: [
                    "description",
                    "orgId",
                    "createdAt",
                  ],
                },
              }}
              content={RowOrgContent}
              attributes={{ base }}

            />
          </Col>
        </Row>
        <div className="mt-4"></div>
        <Row>
          <Col>
            <Link className={"btn btn-primary"} to={`${base}/key/new`}>
              <i className="fa fa-plus" /> Add API Key
            </Link>
          </Col>
        </Row>
        <div className="mt-2"></div>
        <Row>
          <Col>
            <List
              onData={(results, data) => { }}
              path={"viewer.account.domains.get.keys"}
              query={KeyQL.list}
              variables={params}
              schema={schema}
              target={{ $ref: "/Public/Key" }}
              empty={"No API keys yet."}
              more={<Link to={`${base}/key`}>Show more</Link>}
              config={{
                "/Public/Key": {
                  fields: [
                    KeyAccess.keyIdColumn,
                    "roles",
                    "createdAt",
                  ],
                },
              }}
              content={RowKeyContent}
              attributes={{ base }}
              widgets={{ tags, ...KeyAccess.widgets }}

            />
          </Col>
        </Row>
      </Container>
    </>
  );
};


const RowOrgContent = ({
  item: { orgId },
  attributes: { base },
}) => {
  return (
    <>
      <Link className={"btn btn-primary mt-2"} to={`${base}/organization/${orgId}`}>
        View
      </Link>
    </>
  )
};


const RowKeyContent = ({
  item: { keyId },
  attributes: { base },
}) => {
  return (
    <>
      <Link className={"btn btn-primary mt-2"} to={`${base}/key/${keyId}`}>
        View
      </Link>
    </>
  )
};
